<template>
  <div>
      <Header title="教学评价" type="0" route="/student/evaluate" ></Header>
      <NOdata v-if="this.evaluateList.length == 0" :title="warning"></NOdata>
      <div v-else-if="pjflag=='0'" class="eva-body">
        <div class="grey-contain" v-for="(item,index) in evaluateList" :key="index" >
          <div style="width:65%;">
            <h4 class="contain-txt">{{item.kcmc}}</h4>
            <p class="contain-txt1">课程编号：{{item.kch}}</p>
            <div class="contain-txt1">授课教师：<span style="color: #F86969;">{{item.xm}}</span></div>
          </div>
          <div class="history" v-if="item.issave == 1" >
            <h1>{{item.pjdjstr}}</h1>
            <p>评分</p>
          </div>
          <button @click="goEvaluate(item)" v-else>评价</button>
        </div>
      </div>
      <div v-else-if="pjflag=='1'" class="eva-body">
        <div class="grey-contain" v-for="(item,index) in evaluateList" :key="index"  style="min-height:102px">
          <div style="width:65%;">
            <h4 class="contain-txt">{{item.kcmc}}</h4>
            <p class="contain-txt1">课程编号：{{item.kch}}</p>
            <div class="contain-txt1">授课教师：<span style="color: #F86969;">{{item.xm}}</span></div>
            <div class="contain-txt1">总体评价分数：<span style="color: #F86969;">{{item.issave=='0'?'未评':item.pjdjstr}}</span></div>
          </div>
          <div class="history" v-if="item.issave_kc == 1" >
            <h1>{{item.zpf}}</h1>
            <p>评分</p>
          </div>
          
          <div class="history testDiv" v-else-if="item.issave == 1" >
            <p>请输入评分</p>
            <p>
              <input type="text" v-model="kcpfObj[index].zpf"  @change="checkNb(index)"  value="" maxlength="3"/>
            </p>
          </div>
        </div>
        <div class="butDiv">
          <div class="sbmidiv" @click="submitKcpj">提交</div>
        </div>
      </div>
      <div v-else-if="pjflag=='2'" class="eva-body">
        <div class="grey-contain" v-for="(item,index) in evaluateList" :key="index" style="min-height:122px">
          <div style="width:65%;">
            <h4 class="contain-txt">{{item.kcmc}}</h4>
            <p class="contain-txt1">课程编号：{{item.kch}}</p>
            <div class="contain-txt1">授课教师：<span style="color: #F86969;">{{item.xm}}</span></div>
            <div class="contain-txt1">总体评价分数：<span style="color: #F86969;">{{item.pjdjstr}}</span></div>
            <div class="contain-txt1">课程评价分数：<span style="color: #F86969;">{{item.zpf}}</span></div>
          </div>
          <button @click="goEvaluate_sfpj(item)" v-if="item.issfpj=='1'&&item.sftj=='1'">详情</button>
          <button @click="goEvaluate_sfpj(item)" v-else>评价</button>
        </div>
      </div>
      <div class="history-btn">
        <button @click="checkHis('0')" :class="pjflag=='0'?'but_one but_active':'but_one'">总体评价</button>
        <button @click="checkHis('1')" :class="pjflag=='1'?'but_two but_active':'but_two'">课程评价</button>
        <button @click="checkHis('2')" :class="pjflag=='2'?'but_three but_active':'but_three'">师风师德评价</button>
      </div>
  </div>
</template>

<script>
  import {Api} from '../../../utils/axios'
  export default {
    data(){
      return{
        evaluateList:[],
        evaluateZbList:[],
        warning:'',
        pjflag:'0',
        kcpfObj:[],
        queryData:[]
      }
    },
    methods:{
      checkHis(lx){
       this.pjflag = lx;
      },
      checkNb(index){
        const regex = /^[0-9]*$/;
        if(!regex.test(this.kcpfObj[index].zpf)){
          this.$toast("只能输入数字！");
          this.kcpfObj[index].zpf = '';
            return;
        }
        if(this.kcpfObj[index].zpf<this.kcpfObj[index].ksfs||this.kcpfObj[index].zpf>this.kcpfObj[index].jsfs){
          this.$toast("输入的分数只能在"+this.kcpfObj[index].ksfs+'至'+this.kcpfObj[index].jsfs+"之间");
          this.kcpfObj[index].zpf = '';
            return;
        }
      },
      async submitKcpj(){
        for(let i=0;i<this.kcpfObj.length;i++){
          if(this.kcpfObj[i].zpf==''){
            this.$toast("还有课程没有评完！");
            return;
          }
        }
        const params = {
          pjlist:this.kcpfObj,
          pj0502id:this.queryData.pj0502id,
          pj01id:this.queryData.pj01id,
        }
        const res = await Api.submitEvaluateKcpj(params)
        if(res.code=='1'){
          this.$toast("提交成功！");
            this.getEvaluation();
        }
        
      },
      goEvaluate(item){
        let obj = {
          pj09id:item.pj09id,
           kcmc:item.kcmc,
           kch:item.kch,
           teacherName:item.xm,
           issubmit:item.issubmit,
           zbList:this.evaluateZbList,
           issave:item.issave,
          'pj01id': this.queryData.pj01id,
          'batchId': this.queryData.pj0502id,
          'pj05id': this.queryData.pj05id,
          'pj02id': this.queryData.pj02id,
          jg0101id:item.jg0101id
        } 
        this.$router.push({
                  path:'/student/detailEvaluateZtpj',
                  query:{
                    dataObj: JSON.stringify(obj)
                  }
              })
      },
      goEvaluate_sfpj(item){

        let obj = {
          pj09id:item.pj09id,
           kcmc:item.kcmc,
           kch:item.kch,
           teacherName:item.xm,
           issubmit:item.issubmit,
           issave:item.issave,
           jx0404id:item.jx0404id,
          'pj01id': this.queryData.pj01id,
          'batchId': this.queryData.pj0502id,
          'pj05id': this.queryData.pj05id,
          'pj02id': this.queryData.pj02id,
          jg0101id:item.jg0101id,
          iswc:item.issfpj=='1'&&item.sftj=='1'?"1":"0"
        } 
        this.$router.push({
                  path:'/student/detailEvaluateSfpj',
                  query:{
                    dataObj: JSON.stringify(obj)
                  }
              })
      },
      async getEvaluation(){
        const params = {
          'pj01id': this.queryData.pj01id,
          'batchId': this.queryData.pj0502id,
          'pj05id': this.queryData.pj05id,
          'pj02id': this.queryData.pj02id,
        }
        const res = await Api.getTeachEvaluation_ztpj(params)
        this.evaluateList = res.data.kcDataList;
        this.kcpfObj = [];
        this.evaluateList.forEach(item=>{
          let kcpf={};
          kcpf.pj09id=item.pj09id;
          kcpf.zpf=item.zpf;
          kcpf.ksfs = item.ksfs;
          kcpf.kcid = item.jx02id;
          kcpf.jsfs = item.jsfs;
          kcpf.jg0101id = item.jg0101id;
          this.kcpfObj.push(kcpf)
        })
        this.evaluateZbList = res.data.zbDataList;
        if(!this.evaluateList||this.evaluateList.length == 0){
          this.warning = '暂无评价数据'
        }else{
          if(this.queryData.lx){
            this.checkHis(this.queryData.lx)
          }
        }
      }
    },
    created(){
      //this.$store.state.evaOptCheck = []
      if(this.$route.query.queryData){
        this.queryData = JSON.parse(this.$route.query.queryData)
      }else{
        this.queryData = this.$route.query;
      }
      this.getEvaluation()
    },
  }
</script>

<style lang="less" scoped>
.grey-contain{display: flex;align-items: center;}
.grey-contain h4{overflow: hidden;white-space: nowrap;text-overflow: ellipsis;line-height: 22px;}
  .grey-contain button{background-color: @attendance-background-color-1;border-radius: 3px;color: @attendance-color-3;height: 45px;width: 70px;}
  .grey-contain .contain-txt1{line-height: 17px;}
  .grey-contain  p{margin-bottom: 2px;}
  .delay-btn{position: absolute;bottom: 20px;width: 100%;text-align: center;}
  .delay-btn button{background-color: @attendance-background-color-7;color: @attendance-background-color-1;padding: 11px 0;width: 90%;border-radius: 3px;}
  .history{border-radius: 3px;background-color: @attendance-background-color-13;color: @attendance-color-3;height: 45px;width: 100px;display: flex;flex-direction: column;align-items: center;justify-content: center;}
  .history h1{font-size: 16px;font-weight: 400;}
  .history p{font-size: 10px;}
  .eva-body{margin-bottom: 90px;overflow: auto;height: calc(~"100vh - 50px - 83px");}
  .history-btn{position: fixed;bottom: 0;width: 100%;background-color: @attendance-color-3;text-align: center;padding: 0 20px;box-sizing: border-box;}
  .history-btn button{background-color: @attendance-background-color-7;color: @attendance-background-color-1;margin:20px 0;border-radius: 3px;padding: 11px 0}
  .grey-contain_div{display: flex;align-items: center;background-color: white;}
  .but_one{
    width: 25%;
    
  }
  .but_two{
    width: 25%;
  }
  .but_three{
    width: 40%;
  }
  .but_active{
    background-color: #7569f87e !important;
  }

  .butDiv{
    padding: 0px 20px;
    padding-top: 10px;
  }
  .sbmidiv{
    width: 60px;
    height: 30px;
    line-height: 30px;
    background-color: #7469F8;
    text-align: center;
    float: right;
    border-radius: 3px;
    color: #ffffff;
  }

  .testDiv{
    background-color: #7569f827 !important;
    color: #7469F8 !important;
    height: 65px !important;
    text-align: center;
    input{
      width: 80%;
      height: 25px;
      border: #7569f87e 1px solid;
      text-align: center;
      border-radius: 3px;
      background-color: #ffffff;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/student/Evaluate/teachEvaluate_10407.vue